import { useInternalState, assignMswData, serializeQuery } from '../hooks/internalState';
import {
  PostVideoPrivateCommentReactionsResult,
  PostVideoPrivateCommentReactionsOptions,
  PostVideoPrivateCommentReactionsFields,
  postVideoPrivateCommentReactions,
} from '../fetchers/video/private_comment/reactions';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';
import { useGctlConfig } from '../hooks/GctlProvider';

/**
 * DO NOT MODIFY
 * Auto-generated by gctl-plugin-vimeo-hooks
 */

type UsePostVideoPrivateCommentReactionsOptions<
  Fields extends PostVideoPrivateCommentReactionsFields,
> = PostVideoPrivateCommentReactionsOptions<Fields>;

/**
 * Create a clip comment reaction
 * This method creates a clip comment reaction.
 */

export function usePostVideoPrivateCommentReactions<
  Fields extends PostVideoPrivateCommentReactionsFields,
>() {
  const { mutate } = useSWRConfig();
  let { baseUrl, jwt, xVimeoPage, locale } = useGctlConfig();

  let [state, dispatch] = useInternalState<
    PostVideoPrivateCommentReactionsResult<Fields> | undefined
  >();

  let call = useCallback(
    async (options: UsePostVideoPrivateCommentReactionsOptions<Fields>) => {
      dispatch({ type: 'REQUEST' });

      try {
        let result = await mutate(
          `/videos/${options.where.videoId}/private_comments/${
            options.where.commentId
          }/reactions${serializeQuery(options)}`,
          postVideoPrivateCommentReactions({
            ...options,
            baseUrl,
            headers: {
              ...options.headers,
              'Content-Type': 'application/json',
              Authorization: jwt ? `jwt ${jwt}` : '',
              'Vimeo-Page': `${xVimeoPage}`,
              'Accept-Language': locale ?? 'en',
            },
          }),
          false,
        );

        dispatch({ type: 'SUCCESS', payload: result });
      } catch (err) {
        dispatch({ type: 'FAILURE', payload: err });
      }
    },
    [baseUrl, xVimeoPage, jwt, locale, dispatch],
  );

  return [call, state] as const;
}

if (process.env.NODE_ENV !== 'production' || process.env.STORYBOOK === 'true') {
  assignMswData(usePostVideoPrivateCommentReactions, {
    endpoint: '/videos/:videoId/private_comments/:commentId/reactions',
    method: 'POST',
  });
}
